export const setSelectedCommentID = (commentID, dispatch) =>
  dispatch({
    type: 'SET_SELECTED_COMMENT_ID',
    payload: commentID,
  });
